import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatCheckboxModule, MatIconModule, MatMenuModule } from '@angular/material';
import { DirectivesModule } from '../../directives/directives.module';
import { FcListItemComponent } from './fc-list-item.component';

@NgModule({
  entryComponents: [
    FcListItemComponent
  ],
  declarations: [
    FcListItemComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    DirectivesModule
  ],
  exports: [
    FcListItemComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class FcListItemModule {}
